module.exports = __webpack_public_path__ + "h5/img/hong-kong-listing-thumb.72e0c73f.webp";